export default __webpack_public_path__ + "static/media/4_Legal_Compliance_Icon.af801043.svg";